import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import tippy from 'tippy.js';
import { tracked } from '@glimmer/tracking';
import { hideAll } from 'tippy.js';
export default class OrganismsListItemDropdownComponent extends Component {
  @service store;
  @service teams;
  @service router;
  @service('editor-active') editorActiveService;

  innerTippyInstance_workstreams;
  innerTippyInstance_teams;
  innerTippyInstance_weeks;
  @tracked isOpen = false;

  @tracked dynamicList = [];
  listType = null;

  get isWorkstream() {
    return this.args.parentType === 'workstream';
  }

  get isPlanning() {
    return this.args.parentType === 'week';
  }

  get isOther() {
    return this.args.source === 'other';
  }

  get isTeamTFO() {
    return (
      this.args.parentType === 'team' &&
      this.args.type === 'tfo' &&
      this.args?.initiativeTags?.length &&
      true
    );
  }

  get itemWeek() {
    return this.args.item.get('week.id');
  }

  get isLinkedItem() {
    if (this.args.type === 'uncertainty' || this.args.type === 'wfa')
      return false;
    return (
      this.args.item?.get('week')?.isTruthy ||
      // this.args.item?.get('initiative')?.isTruthy ||
      // this.args.item?.get('workstream')?.isTruthy ||
      false
    );
  }

  get showInnerDropdown() {
    return this.isWorkstream || this.isPlanning || this.isTeamTFO;
  }

  @action
  createTippy(element) {
    let trigger = element.querySelector('.list-item-dropdown');
    let dropdown = element.querySelector('.tippy-dropdown');
    let self = this;
    this.tippyInstance = tippy(trigger, {
      content: dropdown,
      arrow: false,
      trigger: 'click',
      interactive: true,
      offset: [-24, 4],
      appendTo: element,
      // is_open: true,
      onShow() {
        self.isOpen = true;
        self.args.onActivate();
        if (self.args.itemSelected) {
          self.args.itemSelected(true);
        }
      },
      onHide() {
        self.isOpen = false;
        // self.innerTippyInstance?.hide?.();
        if (self.args.itemSelected) {
          self.args.itemSelected(false);
        }
      },
    });
  }

  @action
  closeMenu() {
    this.tippyInstance.hide();
    this.is_open = false;
    if (this.args.itemSelected) {
      this.args.itemSelected(false);
    }
  }

  @action
  closeInnerDropdown() {
    hideAll();
  }

  @action
  createComment() {
    this.args.onNewComment();
    this.closeMenu();
  }

  @action
  deleteItem() {
    if (this.args.onDelete) {
      this.args.onDelete();
    } else {
      this.args.item.destroyRecord();
    }
    this.closeMenu();
  }

  @action
  archiveQuestion() {
    let item = this.args.item;
    item.archived = true;
    item.save();
    this.closeMenu();
  }

  @action
  copyLink() {
    const href = window.location.href;
    const baseUrl = href.split('?')[0];
    let urlParams = new URLSearchParams();
    urlParams.append('item', this.args.item.id);
    let url = `${baseUrl}/?${urlParams.toString()}`;
    navigator.clipboard.writeText(url);
    this.closeMenu();
  }

  @action
  deactivateItem() {
    this.editorActiveService.clearActiveEditor();
  }

  @action
  unlinkFromCheckin() {
    this.args.item.team = null;
    this.args.item.save();
    this.closeInnerDropdown();
  }
}
